import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Skeleton,
  Tab,
  Table,
  TableCaption,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  Link,
  Select,
  Checkbox,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Badge,
  UnorderedList,
  ListItem,
  ButtonGroup,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { LinkIcon } from "@chakra-ui/icons";

const ForwardNode = ({
  currentNode,
  forwardNodes,
  isChildNode,
  handleCheckboxChange,
  handleFullRollback,
  handleSelectiveRollback,

  selectedItems,
}) => {
  const [checkedItems, setCheckedItems] = useState([]);

  const handleItemCheckboxChange = (event, id) => {
    const isChecked = event.target.checked;

    // Update checkedItems array
    if (isChecked) {
      setCheckedItems((prevItems) => [...prevItems, id]);
    } else {
      setCheckedItems((prevItems) => prevItems.filter((item) => item !== id));
    }

    handleCheckboxChange(id, isChecked);
  };

  if (!forwardNodes || forwardNodes.length === 0) {
    if (isChildNode) {
      return null; // Stop recursion if there are no child forward nodes
    }
    return (
      <Text ml={4} my={2} fontWeight={"bold"}>
        No Forward Trace Available
      </Text>
    );
  }

  return (
    <Box bg="brand.white">
      <Accordion allowMultiple defaultIndex={isChildNode ? undefined : [0]}>
        {forwardNodes.map((node, index) => (
          <AccordionItem key={node._id}>
            <h2>
              <AccordionButton>
                {/* <Checkbox
                 marginRight={"0.5rem"}
                  isChecked={selectedItems?.tcNumbers?.includes(node?.tcNumber)}
                  onChange={(event) =>
                    handleCheckboxChange(
                      node.tcNumber,
                      event.target.checked,
                      "tcIds"
                    )
                  }
                ></Checkbox> */}
                <>
                  <Box
                    flex="1"
                    textAlign="left"
                    fontWeight="bold"
                    color={isChildNode ? "blue.500" : "black"}
                  >
                    {node?.tcNumber} - {node?.process}
                  </Box>
                  {/* <Button
                    onClick={() => {
                      window.open(`/preview-tc/${node?.tcNumber}`, "_blank");
                    }}
                  >
                    <LinkIcon />
                  </Button> */}
                </>
              </AccordionButton>
            </h2>
            <AccordionPanel>
              <Box ml={4} my={2}>
                <Text fontWeight="bold">Seller Details:</Text>
                <Text ml={4} my={2}>
                  {node?.seller?.name} {`(${node?.seller?.license})`}
                </Text>
                <Text fontWeight="bold"> Buyer Details: </Text>

                <Text ml={4} my={2}>
                  {node?.buyer?.name} {`(${node?.buyer?.license})`}
                </Text>
              </Box>
              {node?.procurements &&
                node?.procurements?.length > 0 && (
                  <UnorderedList listStyleType="none" ml={4} my={2}>
                    {node?.procurements?.map((item) => (
                      <ListItem key={item?._id}>
                        <Checkbox
                         marginRight={"0.5rem"}
                          isChecked={selectedItems?.inventoryIds?.includes(
                            item?.id
                          )}
                          onChange={(event) =>
                            handleCheckboxChange(
                              item?.id,
                              event.target.checked,
                              "inventoryIds", 
                              node?.tcNumber
                            )
                          }
                        ></Checkbox>
                        <Badge colorScheme="green">{item?.id}</Badge>
                        <Box ml={4} my={4}>
                          <Text fontWeight={"bold"} fontSize={"sm"}>
                            Procurement Supplier:
                          </Text>

                          <Text fontSize={"sm"}>
                            {" "}
                            {`${item?.procurement_supplier?.firstName} ${item?.procurement_supplier?.lastName}`}
                          </Text>
                        </Box>
                      </ListItem>
                    ))}
                  </UnorderedList>
                )}
              {node?.inventory && node?.inventory?.length > 0 && (
                <UnorderedList listStyleType="none" ml={4} my={2}>
                  {node?.inventory?.map((item) => (
                    <ListItem key={item?._id}>
                      <Checkbox
                       marginRight={"0.5rem"}
                        isChecked={selectedItems?.inventoryIds?.includes(
                          item?.id
                        )}
                        onChange={(event) =>
                          handleCheckboxChange(
                            item?.id,
                            event.target.checked,
                            "inventoryIds", 
                            node?.tcNumber

                          )
                        }
                      ></Checkbox>
                      <Badge colorScheme="green">{item.id}</Badge>-{" "}
                      {item?.inventory_productClassification?.name} -{" "}
                      {item.quantityReceived}Kg
                    </ListItem>
                  ))}
                </UnorderedList>
              )}

              <ForwardNode
                forwardNodes={node.forwardNodes}
                isChildNode
                handleCheckboxChange={handleCheckboxChange}
              />

              {/* {!isChildNode && (
                <ButtonGroup margin="2rem">
                  <Button
                    bg="#52BBFF"
                    color="#ffffFF"
                    _hover={{ bg: "#52BBFF" }}
                    w="171px"
                    h="50px"
                    onClick={handleFullRollback}
                  >
                    Complete Rollback
                  </Button>
                  <Button
                    bg="#52BBFF"
                    color="#ffffFF"
                    _hover={{ bg: "#52BBFF" }}
                    w="171px"
                    h="50px"
                    onClick={handleSelectiveRollback}
                  >
                    Selective Rollback
                  </Button>
                </ButtonGroup>
              )} */}
              {/* Recursive call */}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
};

const ShowTraceDetails = () => {
  const navigate = useNavigate();
  const [forwardTraceData, setForwardTraceData] = useState([]);
  ;
  const [isLoading, setIsLoading] = useState(false);
  const { tcNumber } = useParams();

  const getForwardTraceData = async () => {
    const token = localStorage.getItem("cu_user");
    setIsLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/trace/admin/${tcNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      ;
      if (data?.status === "success") {
        setForwardTraceData(data?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      ;
    }
  };

  useEffect(() => {
    getForwardTraceData();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const [selectedItems, setSelectedItems] = useState({
    tcIds: [],
    inventoryIds: [],
  });

  ;

  const handleCheckboxChange = (id, isChecked, type, parentTcNumber) => {
    if (isChecked) {
      setSelectedItems((prevItems) => ({
        ...prevItems,
        [type]: [...(prevItems[type] || []), id],
        tcIds: [...(prevItems.tcIds || []), parentTcNumber]
      }));
    } else {
      setSelectedItems((prevItems) => ({
        ...prevItems,
        [type]: prevItems[type].filter((item) => item !== id),
        tcIds: prevItems.tcIds.filter((tc) => tc !== parentTcNumber)
      }));
    }
  };

  //handle full rollback call
  const handleFullRollback = async () => {
    const token = localStorage.getItem("cu_user");
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/trace/roll-back/full`,
            { id: tcNumber },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === "success") {
            resolve(response);
            ;
            navigate(-1);
            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "TC Rollback done Successfully!",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  };

  //selective rollback
  const handleSelectiveRollback = async () => {
    const token = localStorage.getItem("cu_user");
    ;
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/trace/roll-back`,
            selectedItems,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === "success") {
            resolve(response);
            ;
            navigate(-1);
            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "Selective TC Rollback done Successfully!",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  };

  return (
    <Box>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          //#3958DC
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Text
        mt="2rem"
        color={"#141D43"}
        fontSize="2xl"
        fontWeight={"800"}
        fontFamily={"font.roboto"}
      >
        Trace Details
      </Text>
      {isLoading ? (
        <Box p={8} bg={"brand.white"} borderRadius={"0.5rem"} marginTop={"1rem"}>Forward Nodes Loading...</Box>
      ) : (
        <>
          <Box p={8} bg={"brand.white"} borderRadius={"0.5rem"} marginTop={"1rem"}>
            {/* current node */}
            <Accordion allowMultiple defaultIndex>
              <AccordionItem key={forwardTraceData?._id}>
                <h2>
                  <AccordionButton>
                    {/* <Checkbox
                      marginRight={"0.5rem"}
                      isChecked={selectedItems?.tcNumbers?.includes(
                        forwardTraceData?.tcNumber
                      )}
                      onChange={(event) =>
                        handleCheckboxChange(
                          forwardTraceData?.tcNumber,
                          event.target.checked,
                          "tcIds"
                        )
                      }
                    ></Checkbox> */}
                    <>
                      <Box
                        flex="1"
                        textAlign="left"
                        fontWeight="bold"
                        color={"black"}
                      >
                        {forwardTraceData?.tcNumber} -{" "}
                        {forwardTraceData?.process} (Current Node)
                      </Box>
                      {/* <Button
                        onClick={() => {
                          window.open(
                            `/preview-tc/${forwardTraceData?.tcNumber}`,
                            "_blank"
                          );
                        }}
                      >
                        <LinkIcon />
                      </Button> */}
                    </>
                  </AccordionButton>
                </h2>
                <AccordionPanel>
                  <Box ml={4} my={2}>
                    <Text fontWeight="bold">Seller Details:</Text>
                    <Text ml={4} my={2}>
                      {forwardTraceData?.seller?.name}{" "}
                      {`(${forwardTraceData?.seller?.license})`}
                    </Text>
                    <Text fontWeight="bold"> Buyer Details: </Text>

                    <Text ml={4} my={2}>
                      {forwardTraceData?.buyer?.name}{" "}
                      {`(${forwardTraceData?.buyer?.license})`}
                    </Text>
                  </Box>
                  {forwardTraceData?.procurements &&
                    forwardTraceData?.procurements?.length > 0 && (
                      <UnorderedList listStyleType="none" ml={4} my={2}>
                        {forwardTraceData?.procurements?.map((item) => (
                          <ListItem key={item?._id}>
                            <Checkbox
                             marginRight={"0.5rem"}
                              isChecked={selectedItems?.inventoryIds?.includes(
                                item?.id
                              )}
                              onChange={(event) =>
                                handleCheckboxChange(
                                  item?.id,
                                  event.target.checked,
                                  "inventoryIds",
                                  forwardTraceData?.tcNumber

                                )
                              }
                            ></Checkbox>
                            <Badge colorScheme="green">{item?.id}</Badge>
                            <Box ml={4} my={4}>
                              <Text fontWeight={"bold"} fontSize={"sm"}>
                                Procurement Supplier:
                              </Text>

                              <Text fontSize={"sm"}>
                                {" "}
                                {`${item?.procurement_supplier?.firstName} ${item?.procurement_supplier?.lastName}`}
                              </Text>
                            </Box>
                          </ListItem>
                        ))}
                      </UnorderedList>
                    )}
                  {forwardTraceData?.inventory &&
                    forwardTraceData?.inventory?.length > 0 && (
                      <UnorderedList listStyleType="none" ml={4} my={2}>
                        {forwardTraceData?.inventory?.map((item) => (
                          <ListItem key={item?._id}>
                            <Checkbox
                             marginRight={"0.5rem"}
                              isChecked={selectedItems?.inventoryIds?.includes(
                                item?.id
                              )}
                              onChange={(event) =>
                                handleCheckboxChange(
                                  item?.id,
                                  event.target.checked,
                                  "inventoryIds",
                                  forwardTraceData?.tcNumber

                                )
                              }
                            ></Checkbox>
                            <Badge colorScheme="green">{item.id}</Badge>-{" "}
                            {item?.inventory_productClassification?.name} -{" "}
                            {item.quantityReceived}Kg
                          </ListItem>
                        ))}
                      </UnorderedList>
                    )}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
            <ForwardNode
              currentNode={forwardTraceData}
              forwardNodes={forwardTraceData?.forwardNodes}
              handleCheckboxChange={handleCheckboxChange}
              isChildNode={false}
              handleFullRollback={handleFullRollback}
              handleSelectiveRollback={handleSelectiveRollback}
            />

            <ButtonGroup margin="2rem">
              <Button
                bg="#52BBFF"
                color="#ffffFF"
                _hover={{ bg: "#52BBFF" }}
                w="171px"
                h="50px"
                onClick={handleFullRollback}
              >
                Complete Rollback
              </Button>
              <Button
                bg="#52BBFF"
                color="#ffffFF"
                _hover={{ bg: "#52BBFF" }}
                w="171px"
                h="50px"
                onClick={handleSelectiveRollback}
              >
                Selective Rollback
              </Button>
            </ButtonGroup>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ShowTraceDetails;
